import React from 'react';
import * as Proptypes from 'prop-types';

function ContentDiv({ children }) {
  return (
    // Although this is not providing any styling, I'm keeping it here because
    // content blocks across the site are already using it. If we want to
    // add styles to all content blocks in the site, we can do it here. -EB
    <div>{children}</div>
  );
}

ContentDiv.propTypes = {
  children: Proptypes.node,
};

export default ContentDiv;
